module.exports = __webpack_public_path__ + "img/18.16308d7d.jpg";